import { Link } from 'react-router-dom';
import { trackLinkClick } from '../../common/analytics';
import Div from '../../common/components/div';
import H2 from '../../common/components/h2';
import { TermsAndConditionsToggle } from '../../common/components/TermsAndConditionsToggle';
import TranslatedSpan from '../../common/components/TranslatedSpan';
import capitalizeFirstLetter from '../../common/functions/capitalizeFirstLetter';
import translate from '../../common/functions/translate';

export default function TroubleLoggingSection() {

    return <>
        <Div
            isRow
            paddingySM={1}
            paddingyMD={2}
        >
            <Div cols={12}>
                <H2>
                    <TranslatedSpan english={'trouble_logging_in'}/>
                </H2>
            </Div>
        </Div>

        <Div isRow>
            <Div cols={12}>
                <Link
                    to="/forgot-username-and-password"
                    onClick={trackLinkClick(translate('login'))}
                >
                    <TranslatedSpan english={'forgot_username_and_password'}/>
                </Link>
            </Div>
        </Div>

        <Div isRow>
            <Div cols={12}>
                <Link
                    to="/find-my-account"
                    onClick={trackLinkClick(translate('login'))}
                >
                    {capitalizeFirstLetter(translate('find_my_account').toLowerCase())}
                </Link>
            </Div>
        </Div>

        <Div isRow>
            <Div cols={12} colsMD={8} paddingTop={5}>
                <TranslatedSpan english={'using_shared_or_public_computer'}/>
            </Div>
        </Div>
        <Div isRow>
            <Div
                cols={12} colsMD={8}
                className="ds-u-color--gray-light ds-u-font-size--sm"
                paddingTop={3}
                marginBottom={6}
            >
                {`${translate('agree_access_this_site')} `}
                <TermsAndConditionsToggle />
            </Div>
        </Div>
    </>
}
